export default "__VITE_ASSET__BmlPYOkg__"